import { render, staticRenderFns } from "./proView.vue?vue&type=template&id=adf56134&scoped=true"
import script from "./proView.vue?vue&type=script&lang=js"
export * from "./proView.vue?vue&type=script&lang=js"
import style0 from "./proView.vue?vue&type=style&index=0&id=adf56134&prod&lang=scss&scoped=true"
import style1 from "./proView.vue?vue&type=style&index=1&id=adf56134&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf56134",
  null
  
)

export default component.exports